module.exports = __webpack_public_path__ + "static/colors-themes-video-dont-39ce6bfe127eb72661686199d4b05e20.png";